import Routes from "./Routes";
import CookieConsent from "./components/CookieConsent";

function App() {
  return (
    <>
      <CookieConsent />
      <Routes />
    </>
  );
}

export default App;
